import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

const getLeagueSetting = async () => {
  const response = await agent.get(API_URL + 'leagues/setting')
  return response.data
}
const saveLeagueSetting = async (data) => {
  const response = await agent.post(API_URL + 'leagues/setting', data)
  return response.data
}
const getLeagueSummary = async () => {
  const response = await agent.get(API_URL + 'leagues/summary')
  return response.data
}
const getLeagues = async (offset, itemsPerPage, activePage, params) => {
  const response = await agent.get(
    `${API_URL}leagues/listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getLeagueTeams = async () => {
  const response = await agent.get(API_URL + 'leagues/teams')
  return response.data
}
const generateLeagueCode = async () => {
  const response = await agent.get(API_URL + 'leagues/generate-code')
  return response.data
}
const getLeagueDetail = async (id) => {
  const response = await agent.get(`${API_URL}leagues/detail/${id}`)
  return response.data
}
const getLeagueRankings = async (id, roundId) => {
  const response = await agent.get(
    `${API_URL}leagues/rankings/${id}${roundId ? `?round_id=${roundId}` : ''}`,
  )
  return response.data
}
const getLeagueBlockedMembers = async (id) => {
  const response = await agent.get(`${API_URL}leagues/blocked-members/${id}`)
  return response.data
}
const saveLeague = async (data) => {
  const response = await agent.post(API_URL + 'leagues/save', data)
  return response.data
}
const saveLeaguesFromTeams = async (data) => {
  const response = await agent.post(API_URL + 'leagues/save-from-teams', data)
  return response.data
}
const changeJoiningStatus = async (data) => {
  const response = await agent.post(API_URL + 'leagues/joining-status', data)
  return response.data
}
const resetLeagueCode = async (data) => {
  const response = await agent.post(API_URL + 'leagues/reset-code', data)
  return response.data
}
const deleteLeague = async (data) => {
  const response = await agent.post(API_URL + 'leagues/delete', data)
  return response.data
}
const removeMember = async (data) => {
  const response = await agent.post(API_URL + 'leagues/remove-member', data)
  return response.data
}
const allowRejoin = async (data) => {
  const response = await agent.post(API_URL + 'leagues/allow-rejoin', data)
  return response.data
}

const LeagueService = {
  getLeagueSetting,
  saveLeagueSetting,
  getLeagueSummary,
  getLeagues,
  getLeagueTeams,
  generateLeagueCode,
  getLeagueDetail,
  getLeagueRankings,
  getLeagueBlockedMembers,
  saveLeague,
  saveLeaguesFromTeams,
  changeJoiningStatus,
  resetLeagueCode,
  deleteLeague,
  removeMember,
  allowRejoin,
}

export default LeagueService
